module.exports = "/images/flag-th.svg?13b62ddb575f7c9b6e3af0947e409792";